module.exports = __webpack_public_path__ + "img/Nicky_Böhm.f384183d.jpg";